
let swUrl = `${process.env.PUBLIC_URL}/sw.js`


const invokeServiceWorkerUpdateFlow = (registration) => {
    Notification.requestPermission().then((perm) => {
        if (perm == 'granted') {
            const notification = new Notification('KPS مدرسة الكوثر الخاصة',
                {
                    body: 'توجد تحديثات متاحة للموقع .. اضغط للتحميل ! ',
                    icon: '/assets/images/logo-b.png',
                })
            notification.addEventListener('click', () => {
                if (registration.waiting) {
                    // let waiting Service Worker know it should became active
                    registration.waiting.postMessage('SKIP_WAITING')
                }
            })
        }
    })
}

const invokeButton = (registration) => {
    if (registration.waiting) {
        // let waiting Service Worker know it should became active
        registration.waiting.postMessage('SKIP_WAITING')
    }
}

const updateServiceWorker = (registration, status) => {
    // detect Service Worker update available and wait for it to become installed
    registration.addEventListener('updatefound', () => {
        if (registration.installing) {
            // wait until the new Service worker is actually installed (ready to take over)
            registration.installing.addEventListener('statechange', () => {
                if (registration.waiting) {
                    // if there's an existing controller (previous Service Worker), show the prompt
                    if (navigator.serviceWorker.controller) {
                        if (status) {
                            invokeServiceWorkerUpdateFlow(registration)
                            localStorage.setItem('updateServiceWorker', true)
                        } else {
                            invokeButton(registration)
                        }
                    } else {
                        // otherwise it's the first install, nothing to do
                        console.log('Service Worker initialized for the first time')
                        localStorage.setItem('updateServiceWorker', false)
                    }
                }
            })
        }
    })
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
            window.location.reload()
            refreshing = true
        }
    })

}

const updateServiceWorkerButton = async () => {
    if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.register(swUrl)
            .catch(error => {
                console.error('Service worker registration failed:', error)
            })
        if (registration.waiting) {
            invokeButton(registration)
        }
        updateServiceWorker(registration, false)
        localStorage.setItem('updateServiceWorker', false)
    }
}
export {
    invokeServiceWorkerUpdateFlow,
    updateServiceWorker,
    updateServiceWorkerButton,
}